<template>
  <v-container
    fluid
    fill-height
    :style="style"
  >
    <v-layout align-center
    justify-center>
      <v-flex xs11 md4 lg3>
        <v-layout
          elevation-4 wrap  style="background: white;"
          :style="loginBoxStyle"
        >
          <v-flex
            xs12 pt-8 pb-4
          >
            <img v-if="siteConfig.logoImage"
              :src="siteConfig.logoImage"
              class="login-logo"
            >
          </v-flex>
          <v-flex xs12 mb-10 mx-10>
            <v-text-field
              outline
              label="Site"
              v-model="tenant"
              :outlined="siteConfig.inputOutlined"
              :filled="siteConfig.inputFilled"
              :rounded="siteConfig.inputRounded"
              :dense="siteConfig.inputDense"
              @blur="updateSiteConfig()"
              @keyup.enter="login()"
            />
            <v-text-field
              outline
              label="Username"
              v-model="username"
              placeholder=" "
              :outlined="siteConfig.inputOutlined"
              :filled="siteConfig.inputFilled"
              :rounded="siteConfig.inputRounded"
              :dense="siteConfig.inputDense"
              @keyup.enter="login()"
            />
            <v-text-field
              outline
              type="password"
              label="Password"
              v-model="password"
              placeholder=" "
              :outlined="siteConfig.inputOutlined"
              :filled="siteConfig.inputFilled"
              :rounded="siteConfig.inputRounded"
              :dense="siteConfig.inputDense"
              @keyup.enter="login()"
            />
            <v-btn
              :loading="loading"
              @click.prevent="login()"
              block
              :rounded="siteConfig.inputRounded"
            >
              Login
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import api from './../../api.js'

const defaultSiteConfig = {
  loginBackgroundImage: null,
  logoImage: null,
  darkMode: null,
  colorForTopBar: null,
  inputDense: null,
  inputOutlined: null,
  inputFilled: null,
  inputRounded: null,
  colorForInputBackground: null,
  borderRadius: null
}

export default {
  name: 'Login',

  data: () => {
    return {
      localConfig: {
        lastUsedSite: '',
        siteConfigs: {}
      },
      loading: false,
      siteConfig: defaultSiteConfig,
      username: null,
      password: null,
      tenant: 'costa-sandbox'
    }
  },

  created () {
    this.getConfigFromLS()

    if (this.localConfig.lastUsedSite) {
      this.tenant = this.localConfig.lastUsedSite
    }
    if (this.localConfig.siteConfigs[this.tenant]) {
      this.applySiteConfig(this.localConfig.siteConfigs[this.tenant])
    }
  },

  computed: {
    loginBoxStyle () {
      let style = {
        borderRadius: '6px'
      }
      if (this.siteConfig.borderRadius) {
        style.borderRadius = this.siteConfig.borderRadius
      }
      return style
    },

    style () {
      let style = {}
      if (this.siteConfig.loginBackgroundImage) {
        style.background = 'url(' + this.siteConfig.loginBackgroundImage + ')'
        style.backgroundSize = 'cover'
        style.backgroundRepeat = 'no-repeat'
        style.backgroundPosition = 'center center'
      }
      return style
    }
  },

  methods: {

    applySiteConfig (config) {
      this.siteConfig = defaultSiteConfig
      this.$nextTick(() => {
        this.siteConfig = config
      })
    },

    resetConfig () {
      this.siteConfig = defaultSiteConfig
    },

    updateSiteConfig () {
      if (!this.tenant) {
        return
      }
      this.localConfig.lastUsedSite = this.tenant
      if (this.localConfig && this.tenant && this.localConfig.siteConfigs[this.tenant]) {
        this.applySiteConfig(this.localConfig.siteConfigs[this.tenant])
      } else {
        this.resetConfig()
      }
      this.saveConfigToLS()
      let apiUrl = this.$store.state.apiBaseUrl + '' + this.tenant
      api.getListItems(apiUrl, 'configSets', []).then(response => {
        if (response && response.items && response.items[0]) {
          this.localConfig.siteConfigs[this.tenant] = response.items[0]
          this.applySiteConfig(this.localConfig.siteConfigs[this.tenant])
          this.saveConfigToLS()
        } else {
          this.resetConfig()
        }
      })
      // Get updated site config from API
    },

    getConfigFromLS () {
      let fromLS = window.localStorage.getItem('localConfig')
      if (fromLS) {
        try {
          let json = JSON.parse(fromLS)
          if (json) {
            this.localConfig = json
          }
        } catch (e) {
          console.log('json error', e)
        }
      }
    },

    saveConfigToLS () {
      window.localStorage.setItem('localConfig', JSON.stringify(this.localConfig))
    },

    login () {
      this.loading = true
      this.$store.dispatch('login', {
        tenant: this.tenant,
        username: this.username,
        password: this.password
      }).then(() => {
        this.loading = false
      })
    },

    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style>
.login-logo {
  max-width: 80%;
  max-height: 100px;
}
@-webkit-keyframes autofill {
    0%,100% {
        color: #666;
        background: transparent;
    }
}

input:-webkit-autofill {
    -webkit-animation-delay: 1s; /* Safari support - any positive time runs instantly */
    -webkit-animation-name: autofill;
    -webkit-animation-fill-mode: both;
}
</style>
